import React from "react"
import { DonutMathResponse } from "../models/donuts"
import * as models from "../models/index"
import DonutChart from "./DonutChart"
import SubtractionIcon from "./DonutIcons/Subtraction"
import { RequestError } from "models/lib/modelRequest"
import { toast } from "react-toastify"

export default class SubtractionDonut extends React.Component<{
  studentID?: string
  onLoaded?: (donutsResponse: DonutMathResponse) => void
  refresh?: boolean
}, {
  donutData: DonutMathResponse
  loading: boolean
}> {
  state = {
    loading: true,
    donutData: null
  }

  componentDidMount() {
    this.loadDonuts()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.refresh && this.props.refresh) {
      this.loadDonuts()
    }
  }

  loadDonuts = async () => {
    models.donuts.getMathProgress({
      studentID: this.props.studentID
    }).then((donutData) => {
      this.setState({ donutData }, () => {
        if (typeof this.props.onLoaded === 'function') {
          this.props.onLoaded(donutData)
        }
      })
    }).catch((error: RequestError) => {
      toast.error(error)
    }).finally(() => {
      this.setState({ loading: false })
    })
  }

  render() {

    if (this.state.loading) {
      return <></>
    }

    var { subtraction } = this.state?.donutData
    return (
      <div className="text-center">
        <DonutChart
          label="Subtraction"
          total={subtraction.total}
          completed={subtraction.completed}
          baseColor={"#DF554B"}
          Icon={SubtractionIcon}
        />
      </div>
    )
  }
}
